import { useEmailDomainRowIndicator } from '@/hooks/useEmailDomainRowIndicator';

type DraftRowDomainIndicatorProps = {
  email: string | null;
};

export function DraftRowDomainIndicator({ email }: DraftRowDomainIndicatorProps) {
  const indicator = useEmailDomainRowIndicator(email);

  if (indicator === 'none') {
    return <span className='inline-block w-5 shrink-0' aria-hidden />;
  }

  if (indicator === 'loading') {
    return (
      <span
        className='inline-flex w-5 h-5 shrink-0 items-center justify-center'
        title='Checking email domain…'
        aria-label='Checking email domain'
      >
        <span className='h-3.5 w-3.5 rounded-full border-2 border-gray-300 border-t-primary animate-spin' />
      </span>
    );
  }

  if (indicator === 'bad') {
    return (
      <span
        className='inline-flex w-5 shrink-0 items-center justify-center text-base leading-none'
        title='Domain failed checks — review or skip'
        aria-label='Domain failed checks'
        role='img'
      >
        💀
      </span>
    );
  }

  return (
    <span
      className='inline-flex w-5 shrink-0 items-center justify-center text-base leading-none'
      title='Domain looks healthy'
      aria-label='Domain looks healthy'
      role='img'
    >
      🙂
    </span>
  );
}
